import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, FileButton, Grid, Group, MultiSelect, useSafeMantineTheme } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { createB2BAPI } from '../../api/Interceptor';
import B2BInput from '../../components/common/B2BInput';
import B2BModal from '../../components/common/B2BModal';
import B2BSelect from '../../components/common/B2BSelect';
import notify from '../../utils/Notification';
import AddBrand from './AddBrand';
import { MappedProductContext } from '../../Context/MappedProductContext';

const divStyle = { display: 'flex', alignItems: 'center', gap: '0.5rem' }
const MappedProductType = ({ vendorId }) => {
    // const { stateData } = useContext(ActiveTabContext);
    const initialData = {
        name: "",
        status: "ACTIVE",
        fromDate: "",
        toDate: "",
        seasonCode: ""

    }
    const { product, setProduct, handleChange, setImageFile, imageFile, inputError, vendorImageFile, setVendorImageFile, selectedProducts } = useContext(MappedProductContext);
    const [brand, setBrand] = useState([]);
    const [productTags, setProductTags] = useState([]);
    const [taxonomy, setTaxonomy] = useState([]);
    const [open, setOpen] = useState(false);
    const [modalContent, setModalContent] = useState(initialData);
    const [activeComponent, setActiveComponent] = useState('');
    const [contentUpdated, setContentUpdated] = useState(false)
    const [imageError, setImageError] = useState('');
    const [season, setSeason] = useState([]);
    const [openSeason, setOpenSeason] = useState(false);
    const [selectedUOM, setSelectedUOM] = useState("Kg"); // Default selection
    const [mappedRib, setMappedRib] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 500);

    const B2B_API = createB2BAPI();
    const resetRef = useRef(null);

    useEffect(() => {
        fetchAllBrand();
        fetchAllTags();
        getAllTaxonomy();
        getAllSeason();
    }, [contentUpdated]);

    useEffect(() => {
        fetchAllMappedRib();
    }, [debouncedSearchTerm, product?.mappedFabric])

    const fetchAllBrand = async () => {
        try {
            const res = await B2B_API.get(`brand`).json();
            setBrand(res.response);
        } catch (err) {
            console.error("Failed to Fetch Brand");
        }
    };

    const fetchAllMappedRib = async () => {
        try {
            const res = await B2B_API.get(`product/fabricProduct/search?searchTerm=${debouncedSearchTerm}&productsId=${product?.mappedFabric || []}`).json();
            setMappedRib(res.response.content);
        } catch (err) {
            console.error("Failed to Fetch Brand");
        }
    };

    const fetchAllTags = async () => {
        try {
            const res = await B2B_API.get(`product-tag`).json();
            setProductTags(res.response);
        } catch (err) {
            console.error("Failed to Fetch Brand");
        }
    };

    const clearFile = () => {
        if (resetRef.current) {
            resetRef.current();
        }
        setImageFile(null)
        // setCurrentImage(null)
    };

    const fileChange = (file) => {
        const MAX_SIZE_BYTES = 3 * 1024 * 1024; // 3MB

        if (file) {
            if (file.size > MAX_SIZE_BYTES) {
                setImageError('File size should be less than 3MB');
                setImageFile(null); // Clear the file if it exceeds the size limit
            } else {
                setImageError(''); // Clear any previous errors
                setImageFile(file); // Set the file if it meets the size requirement
                setProduct(prev => ({
                    ...prev,
                    image: URL.createObjectURL(file)
                }))
            }
        } else {
            setImageFile(null);
        }
    };


    const renderUOMText = () => {
        const { unitOfMeasures } = product.otherInformation || ''
        const json = [

            {
                label: "Meter",
                value: product.otherInformation.meter,
                onChange: (event) => handleChange(event, "meter"),
                type: "number",
                fieldType: 'textField',
                placeholder: "Enter Meter",
                visible: unitOfMeasures?.isMeter
            },
            {
                label: "Yard",
                value: convertMeterToYard(),
                onChange: (event) => handleChange(event, "yard"),
                type: "number",
                fieldType: 'textField',
                placeholder: "Enter Yard",
                visible: unitOfMeasures?.isYard
            },
        ];

        const inputFields = json.map((item, index) => {
            return item.visible && <B2BInput
                key={index}
                type={item.type}
                value={item.value}
                onChange={item.onChange}
                placeholder={item.placeholder}
                style={{
                    width: '5rem',
                    height: '30px',
                    marginBottom: '1rem',
                }}

            />
        }
        );

        return inputFields.length > 0 ? (
            <div style={{ display: 'flex', gap: '.5rem' }}>
                {inputFields}
            </div>
        ) : null;
    };


    const convertMeterToYard = () => {
        const res = product.otherInformation.meter * 1.09632;
        return res.toFixed(2);
    }

    const handleUOMChange = (value) => {
        if (value !== "Roll") {
            setSelectedUOM(value); // Only one selection allowed for the other options
            handleChange(value, "UOM", "uomErrorMessage"); // Update state
        }
    };

    const json = useMemo(() => [
        {
            label: "Product Id",
            value: product?.articleCode,
            onChange: (event) => handleChange(event, "articleCode", "articleNameErrorMessage"),
            type: "text",
            fieldType: 'textField',
            disabled: true
        },
        {
            label: "Product Name",
            value: product?.articleName,
            onChange: (event) => handleChange(event, "articleName", "articleNameErrorMessage"),
            type: "text",
            fieldType: 'textField',
            require: true,
            placeholder: "Enter Product Name",
            error: inputError.articleNameErrorMessage,
            disabled: product?.articleCode
        },
        {
            label: "Barcode",
            type: 'radio',
            value: product?.isCreateBarcode,
            fieldType: 'radioField',
            require: true,
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false }
            ],
            onChange: (event) => handleChange(event, "isCreateBarcode", "barcodeErrorMessage"),
            name: "barcode",
            checked: product?.isCreateBarcode,
            error: inputError?.barcodeErrorMessage
        },
        // {
        //     label: "UOM",
        //     value: {
        //         isKg: product?.otherInformation.unitOfMeasures?.isKg || false,
        //         isRoll: product?.otherInformation.unitOfMeasures?.isRoll || false,
        //         isMeter: product?.otherInformation.unitOfMeasures?.isMeter || false,
        //         isYard: product?.otherInformation.unitOfMeasures?.isYard || false
        //     },
        //     onChange: (values) => handleChange(values, "UOM", "uomErrorMessage"),
        //     type: "checkbox",
        //     fieldType: 'checkBoxField',
        //     options: [
        //         { label: "Roll", value: "isRoll" },
        //         { label: "Kg", value: "isKg" },
        //         { label: "Meter", value: "isMeter" },
        //         { label: "Yard", value: "isYard" }
        //     ],
        //     name: 'UOM',
        //     placeholder: "Select UOM Type",
        //     require: true,
        //     className: "form-group",
        //     style: { display: "flex", flexWrap: "wrap", gap: "10px" },
        //     error: inputError?.uomErrorMessage,
        //     checked: (product?.otherInformation?.unitOfMeasures?.isRoll)
        // },
        {
            label: "UOM",
            onChange: (value) => handleChange(value, "UOM", "uomErrorMessage"),
            type: "radio",
            fieldType: "radioField",
            options: [
                { label: "Kg", value: "isKg", },
                { label: "Meter", value: "isMeter" },
                { label: "Yard", value: "isYard" }
            ],
            roll: { label: "Roll", value: "isRoll", disabled: true },
            name: "UOM",
            placeholder: "Select UOM Type",
            require: true,
            className: "form-group",
            disabled: product?.productId,
            style: { display: "flex", flexWrap: "wrap", gap: "10px" },
            error: inputError?.uomErrorMessage,
            // checked: {
            //     isKg: product?.otherInformation.unitOfMeasures?.isKg || false,
            //     isMeter: product?.otherInformation.unitOfMeasures?.isMeter || false,
            //     isYard: product?.otherInformation.unitOfMeasures?.isYard || false
            // }
            uomchecked: (option) => product?.otherInformation?.unitOfMeasures?.[option?.value] || false
        },
        {
            label: "Taxonomy",
            value: product?.taxonomyNode?.id,
            data: taxonomy ? taxonomy.map(b => ({ label: b.name, value: b.id })) : [],
            onChange: (event) => handleChange(_.find(taxonomy, tax => tax.id === event), "taxonomyNode", "taxonomyErrorMessage"),
            type: "Select",
            fieldType: 'selectField',
            placeholder: "Enter Taxonomy",
            clearable: true,
            require: true,
            error: inputError.taxonomyErrorMessage,
            masterCreation: true,
            masterNew: 'Create Taxonomy',
            name: 'Taxonomy'
        },
        {
            label: "Brand",
            value: product?.brandId,
            onChange: (event) => handleChange(event, "brandId"),
            type: "select",
            name: 'Brand',
            fieldType: 'selectField',
            placeholder: "Enter Brand",
            data: brand ? brand.map(b => ({ label: b.name, value: b.brandId })) : [],
            clearable: true,
            masterCreation: true,
            masterNew: 'Create Brand',
        },
        {
            label: "Product Tag",
            type: "multiselect",
            name: 'Product-Tag',
            fieldType: 'multiselectField',
            placeholder: "Enter Tag",
            masterCreation: true,
            masterNew: 'Create Product Tag',
        },
        // {
        //     label: "Generate Batch",
        //     type: 'radio',
        //     value: product?.createBatch,
        //     fieldType: 'radioField',
        //     options: [
        //         { label: "Yes", value: true},
        //         { label: "No", value: false }
        //     ],
        //     onChange: (event) => handleChange(event, "createBatch"),
        //     name: "createBatch",
        //     checked: product?.createBatch
        // },
        {
            label: "Generate Swatch",
            type: 'checkbox',
            value: product?.swatchCreated || product?.swachCardStatus,
            fieldType: 'checkBox',
            onChange: (event) => handleChange(event, "swachCardStatus"),
            name: "swachCardStatus",
            checked: product?.swachCardStatus,
            disabled: product?.swatchCreated
        },
        {
            label: "Status",
            type: 'radio',
            value: product?.status,
            fieldType: 'radioField',
            options: [
                { label: "ACTIVE", value: "ACTIVE" },
                { label: "INACTIVE", value: "INACTIVE" }
            ],
            onChange: (event) => handleChange(event, "status"),
            name: "status",
            checked: product?.status
        },
        {
            label: "Sell as Combo",
            type: 'checkbox',
            value: product?.sellAscombo,
            fieldType: 'checkBox',
            onChange: (event) => handleChange(event, "sellAscombo"),
            name: "sellAscombo",
            checked: product?.sellAscombo,
            // disabled:product?.swatchCreated
        },
        {
            label: "Description",
            value: product?.description,
            onChange: (event) => handleChange(event, "description"),
            type: "textarea",
            fieldType: 'textAreaField',
            placeholder: "Enter Description",
            rows: 1,
            cols: 50,
            error: inputError.descErrorMessage,
        },
        {
            label: "Season",
            value: product?.seasonId,
            onChange: (event) => handleChange(event, "seasonId"),
            type: "select",
            name: 'Season',
            fieldType: 'selectField',
            placeholder: "Enter Season",
            data: season?.map(s => ({
                label: s?.name,
                value: s?.id
            })),
            clearable: true,
            masterCreation: true,
            masterNew: 'Create Season',
        },
        {
            label: "HSN Code",
            value: product?.hsnCode,
            onChange: (event) => handleChange(event, "hsnCode", "hsnCodeNameErrorMessage"),
            type: "text",
            fieldType: 'textField',
            require: !product?.orderDriven,
            disabled: Boolean(product?.orderDriven),
            placeholder: "Enter HSN Code",
            error: inputError.hsnCodeNameErrorMessage,
        },
        {
            label: "Map Main Fabric",
            value: product?.mappedFabric || [],
            onChange: (selectedCodes) => {

                handleChange(selectedCodes, "mappedFabric", "ribErrorMessage")
            },
            data: mappedRib.map(item => ({
                label: item.articleName,
                value: item.articleCode
            })),
            type: "multiselect",
            fieldType: 'multiselect',
            placeholder: "Select Rib Name",
            disabled: product?.taxonomyNode?.name !== 'Rib',
            searchable: true,
            clearable: true,
            require: product?.taxonomyNode?.name === 'Rib' ? true : false,
            onSearchChange: (search) => {
                setSearchTerm(search);
            },
            error: inputError?.ribErrorMessage ?? undefined

        }
    ], [mappedRib, product, inputError])

    const handleSelectChange = (value) => {
        const group = _.find(groups, gr => gr.name === value);
        setCategoryTree(prevTree => [{ ...prevTree[0], productGroup: group }]);
    };

    const getAllTaxonomy = async () => {
        const res = await B2B_API.get("taxonomy").json();
        setTaxonomy(res.response);
    }

    const handleOpenModal = (key) => {
        setActiveComponent(key)
        setModalContent(prev => ({ ...prev, title: key }))
        if (key.toLowerCase() === 'season') {
            setOpenSeason(true);
        } else {
            setOpenSeason(false)
        }
        setOpen(true);
    }

    const handleModalChange = (event, key) => {
        setModalContent((prev => ({ ...prev, [key]: event?.target?.value ? event?.target?.value : event })))
    }

    const saveData = async (e, key) => {
        e.preventDefault();
        try {
            await B2B_API.post(`${key?.toLowerCase()}`, { json: modalContent }).json();
            setOpen(false);
            setContentUpdated(prev => !prev)
            setModalContent(initialData)
            notify({
                title: 'Success!',
                message: `${modalContent.title}` + ' added Successfully.',
                error: false,
                success: true,
            });
        } catch (e) {
            notify({
                error: true,
                success: false,
                title: e?.message
            });
        }
    }

    const handleClose = () => {
        setOpen(false)
        setOpenSeason(false)
    }

    const renderModalChild = () => {
        return <AddBrand onClose={handleClose} modalContent={modalContent} handleModalChange={handleModalChange} saveData={saveData} openSeason={openSeason} />
    }

    const getAllSeason = async () => {
        try {
            const res = await B2B_API.get(`season`).json();
            setSeason(res.response);
        }
        catch (e) {
            console.log("Fail to Fetch Season", e);

        }
    }

    return (
        <div className='productType-container' style={{ display: 'flex', flexDirection: 'column', margin: '2rem' }}>
            <form className='form-container'>
                <Grid gutter={"xs"}>
                    {json?.map((field, index) => (
                        <Grid.Col key={index} span={6} display={"flex"}>
                            <Grid.Col span={3}>
                                <label>{field.label}
                                    {field.require && <span className="error-message"> *</span>}
                                </label>
                            </Grid.Col>
                            <Grid.Col span={9}>
                                {
                                    field.fieldType === 'textField' && (
                                        <B2BInput
                                            value={field.value}
                                            className='input-textField'
                                            style={field.style}
                                            disabled={true}
                                            onChange={field.onChange}
                                            type={field.type}
                                            placeholder={field.placeholder}
                                            error={field.error}
                                        />
                                    )
                                }
                                {
                                    field.fieldType === "selectField" && (
                                        <div style={divStyle}>
                                            <B2BSelect
                                                data={field.data || []}
                                                value={field.value || ""}
                                                onChange={field.onChange}
                                                placeholder={field.placeholder}
                                                clearable={field.clearable}
                                                error={field.error}
                                                disabled={true}
                                                maxDropdownHeight={400}
                                                className='input-textField'
                                            />
                                            {field.masterCreation && (<FontAwesomeIcon icon={faCirclePlus} title={field.masterNew} onClick={() => handleOpenModal(field.name)} size='xl' />)}
                                        </div>
                                    )
                                }
                                {
                                    field.fieldType === 'multiselectField' && (
                                        <div style={divStyle}>
                                            <MultiSelect
                                                value={product?.tags || []}
                                                style={{ width: '250px', height: '2rem !important' }}
                                                placeholder="Tags"
                                                // withScrollArea={true}
                                                hidePickedOptions
                                                disabled={true}
                                                size='xs'
                                                data={productTags.map(tag => tag.name) || []}
                                                onChange={(selectedTags) => handleChange({ target: { value: selectedTags } }, "tags")}

                                            />
                                            {field.masterCreation && (<FontAwesomeIcon icon={faCirclePlus} title={field.masterNew} onClick={() => handleOpenModal(field.name)} size='xl' />)}
                                        </div>
                                    )
                                }
                                {
                                    field.fieldType === 'multiselect' && (
                                        <div style={divStyle}>
                                            <MultiSelect
                                                value={field.value || []}
                                                style={{ width: '250px', height: '2rem !important' }}
                                                placeholder={field.placeholder}
                                                onChange={field.onChange}
                                                data={field.data || []}
                                                disabled={true}
                                                searchable={field.searchable}
                                                hidePickedOptions
                                                size='xs'
                                                onSearchChange={field.onSearchChange}
                                                clearable={field.clearable}
                                            />
                                            {field.error && (
                                                <div className="error-message">{field.error}</div>
                                            )}
                                        </div>

                                    )
                                }
                                {
                                    field.fieldType === 'textAreaField' && (
                                        <div>
                                            <textarea
                                                value={field.value}
                                                className='form-input-textarea'
                                                disabled={true}
                                                onChange={field.onChange}
                                                placeholder={field.placeholder}
                                            />
                                            {field.error && (
                                                <div className="error-message">{field.error}</div>
                                            )}
                                        </div>
                                    )
                                }
                                {/* {field.fieldType === "checkBoxField" && (
                                    <div>
                                        <div className="checkbox-group" style={{ display: 'flex', gap: '1rem' }}>
                                            {field.options.map((option, idx) => (
                                                <div key={idx}>
                                                    <input
                                                        type={field.type}
                                                        value={option.value}
                                                        onChange={field.onChange}
                                                        style={field.style}
                                                        checked={
                                                            product?.otherInformation.unitOfMeasures?.[option.value]
                                                        }
                                                        disabled={option?.value === 'isRoll'}
                                                    />
                                                    <label className='checkbox-label'>{option.label}</label>
                                                </div>
                                            ))}
                                            {field?.error && (
                                                <span className='error-message'>
                                                    {field?.error}
                                                </span>
                                            )}
                                        </div>
                                        {renderUOMText()}
                                        <div>{inputError?.kgErrorMessage}</div>
                                    </div>
                                )} */}
                                {field.fieldType === "checkBox" && (
                                    <div className="checkbox-group" >
                                        <div className="checkbox-item">
                                            <input
                                                type={field.type}
                                                value={field.value}
                                                onChange={field.onChange}
                                                style={field.style}
                                                checked={
                                                    field.value || false
                                                }
                                                disabled={true}
                                            />

                                        </div>
                                        {field?.error && (
                                            <span className='error-message'>
                                                {field?.error}
                                            </span>
                                        )}
                                    </div>
                                )}
                                {field.fieldType === "radioField" && (
                                    <div className="radio-group" style={{ justifyContent: 'normal' }}>
                                        {field?.roll && <> <input
                                            type="radio"
                                            value={field?.roll?.value}
                                            name={field?.roll?.name}
                                            checked={true}
                                            disabled={true}
                                        />
                                            <label className='radio-label'>{field?.roll?.label}</label></>}
                                        {field.options.map((option, idx) => (
                                            <div key={idx} className="radio-item" style={{ display: "flex", gap: '0.5rem' }}>
                                                <input
                                                    type="radio"
                                                    value={option?.value}
                                                    name={field.name}
                                                    onChange={field?.onChange}
                                                    disabled={true}
                                                    // checked={product?.otherInformation?.unitOfMeasures?.[option.value] || false}
                                                    checked={field.uomchecked ? field.uomchecked(option) : field.checked === option.value}
                                                />
                                                <label className='radio-label'>{option.label}</label>
                                            </div>
                                        ))}
                                        {field?.error && (
                                            <span className='error-message'>
                                                {field?.error}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </Grid.Col>
                        </Grid.Col>
                    ))}
                    <div className='form-group' style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ textAlign: 'center', marginBottom: '1rem', border: '1px solid #ccc', padding: '10px', width: '150px', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
                            {imageFile ? (
                                <img
                                    src={`${URL.createObjectURL(imageFile)}?time=${Date.now()}`}
                                    alt="Uploaded"
                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                />
                            ) : (
                                <p style={{ color: '#888' }}>No image uploaded</p>
                            )}
                            {imageError && notify({
                                title: 'Error!!',
                                message: imageError || 'Failed to add Image.',
                                error: true,
                                success: false,
                            })}
                        </div>
                        {/* <Group justify="flex-start">
                            <FileButton resetRef={null} onChange={fileChange} accept="image/png,image/jpeg">
                                {(props) => <Button {...props}>{product?.id ? "Update Image " : "Add Image"}</Button>}
                            </FileButton>
                            <Button disabled={!imageFile} color="red" onClick={clearFile}>
                                Reset
                            </Button>
                        </Group> */}
                    </div>
                    <B2BModal opened={open} size={'lg'} title={modalContent.title} close={() => {
                        setModalContent(initialData);
                        setOpen(false)
                    }}
                    >
                        {renderModalChild()}
                    </B2BModal>
                </Grid>
            </form>
        </div>
    );
};

export default MappedProductType;